import { NumberFilterOptions } from "components/config/grid-templates/predefined-filters";
import { moneyComparator, valueComparator } from "components/widgets/grid/comparator-helpers";
import { CustomColumnType } from "components/widgets/grid/grid-column-types";
import { getValue } from "components/widgets/grid/value-helpers";
import { VisitNodePassage } from "hooks/widget-data/datapoints-api/types";
import { language } from "language/default";
const mLanguage = language.en.grid;
const sortRowMeasuresByColumnId = (rowMeasures, colId, filterDirection, valueType) => {
    const sortMethod = valueType === CustomColumnType.InsMoneyColumn ? moneyComparator : valueComparator;
    const compareMethod = filterDirection === NumberFilterOptions.top
        ? (a, b) => sortMethod(b, a)
        : sortMethod;
    const compare = (aValue, bValue) => {
        if (filterDirection === NumberFilterOptions.bottom) {
            if (bValue === undefined || bValue === null) {
                return -1;
            }
            else if (aValue === undefined || aValue === null) {
                return 1;
            }
        }
        return compareMethod(aValue, bValue);
    };
    rowMeasures?.sort((a, b) => {
        const aValue = getValue(a.measures, colId);
        const bValue = getValue(b.measures, colId);
        return compare(aValue, bValue);
    });
};
const findColumnById = (columns, colId) => {
    for (const column of columns) {
        if (column.children) {
            const childColumn = findColumnById(column.children, colId);
            if (childColumn) {
                return childColumn;
            }
        }
        else if (column.field === colId) {
            return column;
        }
    }
    return undefined;
};
const flatMapNestedDataNodes = (data) => data.flatMap((item) => (item.data ? flatMapNestedDataNodes(item.data) : item));
const processFilteredRows = (flattenRowMeasures, filterRowCountLimitNumber, columnGroupHeaderName, otherGroupHeaderName) => {
    const filteredRowMeasures = flattenRowMeasures.slice(0, filterRowCountLimitNumber);
    filteredRowMeasures.forEach((rowMeasures) => {
        rowMeasures.measures = { ...rowMeasures.measures, CustomGroup: columnGroupHeaderName };
    });
    const otherRowMeasures = flattenRowMeasures.slice(filterRowCountLimitNumber);
    otherRowMeasures.forEach((rowMeasures) => {
        rowMeasures.measures = { ...rowMeasures.measures, CustomGroup: otherGroupHeaderName };
    });
};
export const gridTopFilterFunc = (fallbackColumnId, fallbackDirection, fallbackLimit) => (args) => {
    const widgetState = args.context.widgetState ?? {};
    const filterColumnId = widgetState?.filterColumnId || fallbackColumnId;
    const filterDirection = widgetState?.filterDirection || fallbackDirection;
    const filterRowCountLimit = widgetState?.filterRowCountLimit || fallbackLimit;
    if (!filterColumnId || !filterDirection || !filterRowCountLimit) {
        return;
    }
    if (args.context.visitNodePassage !== VisitNodePassage.RootLast) {
        return;
    }
    const columns = args.context.componentProps?.columnsTemplate.columns ?? [], dataRootNode = args.context.staticData.root, filterRowCountLimitNumber = parseInt(filterRowCountLimit, 10), flattenRowMeasures = flatMapNestedDataNodes(dataRootNode);
    const column = findColumnById(columns, filterColumnId);
    if (column) {
        sortRowMeasuresByColumnId(flattenRowMeasures, filterColumnId, filterDirection, column.type);
        const columnGroupHeaderName = mLanguage.groupedTopFilter(filterDirection, filterRowCountLimit, column?.headerName ?? ""), otherGroupHeaderName = mLanguage.otherGroup;
        processFilteredRows(flattenRowMeasures, filterRowCountLimitNumber, columnGroupHeaderName, otherGroupHeaderName);
    }
};
